import React from 'react';

export function scrollToElement(
	el: React.RefObject<HTMLElement>,
	toEnd: boolean = true,
) {
	if (el?.current) {
		el.current.scrollIntoView({
			block: toEnd ? 'end' : 'start',
			inline: 'nearest',
			behavior: 'smooth',
		});
	}
}
